import * as React from 'react';
import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import { Provider } from 'react-redux';

import '../../utils/baseStyles.css';
import { ApplicationContext } from '../../utils/applicationContext';
import { IApplicationProps } from '../App';
import { DailyrentPageContainer } from '../DailyrentPageContainer/DailyrentPageContainer';
import { NewAnswerModalContainer } from '../NewAnswerModal';
import { RatingInformationModal } from '../RatingInformationModal';
import { DailyrentNewReviewModalContainer } from '../DailyrentNewReviewModal';

export const DailyrentApplication: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { userAgent },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={uaToDeviceType(userAgent || undefined)}>
          <Provider store={reduxStore}>
            <DailyrentPageContainer />
            <NewAnswerModalContainer />
            <DailyrentNewReviewModalContainer />
            <RatingInformationModal />
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
